import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { z } from "zod";

const ActiveTransactionSchema = z.object({
  products: z
    .array(
      z.object({
        _id: z.string(),
        eid: z.string().optional(),
      })
    )
    .optional(),
});

export async function getEventIdByGetTicketId(
  orderId: string,
  ticketId: string
): Promise<string> {
  const { currentUser } = firebase.auth();
  if (!currentUser) {
    throw new Error("User not authenticated");
  }
  const userId = currentUser.uid;

  const transactionRef = firebase
    .firestore()
    .doc(`settlement/${userId}/activeTransactions/${orderId}`);
  const transactionSnapshot = await transactionRef.get();
  if (!transactionSnapshot.exists) {
    throw new Error(`Transaction not found: orderId=${orderId}`);
  }

  const transactionData = transactionSnapshot.data();
  const parsed = ActiveTransactionSchema.safeParse(transactionData);
  if (!parsed.success) {
    throw new Error(`Invalid transaction data: ${parsed.error.message}`);
  }
  const transaction = parsed.data;

  if (
    !Array.isArray(transaction.products) ||
    transaction.products.length === 0
  ) {
    throw new Error(`Products not found: orderId=${orderId}`);
  }

  const matchedProduct = transaction.products.find(
    (product) => product._id === ticketId
  );
  if (!matchedProduct) {
    throw new Error(`Product not found: ticketId=${ticketId}`);
  }

  const eventId = matchedProduct.eid;
  if (!eventId) {
    throw new Error(`Event ID not found: ticketId=${ticketId}`);
  }

  return eventId;
}
